import React from "react";
import { useLocation } from "react-router-dom";
import HeroBanner from "@/components/HeroBanner";
import { HEROES, NAV_ICONS } from "@/lib/brandImages";

const ROUTE_HERO = { "/office": "office", "/oracle": "oracle", "/fliers": "fliers", "/population": "population", "/frigates": "frigates", "/library": "library", "/directory": "directory", "/progress": "progress", "/feedback": "feedback", "/invite": "invite", "/command": "command" };

// Page header: renders the realistic photo banner for the current route, plain header elsewhere
export default function PageHeader({ eyebrow, title, description, children, image, icon }) {
  const { pathname } = useLocation();
  const key = ROUTE_HERO[pathname];
  const img = image || (key ? HEROES[key] : null);
  if (img) return <HeroBanner image={img} icon={icon || NAV_ICONS[pathname]} eyebrow={eyebrow} title={title} description={description} testid={`hero-${pathname.replace("/", "") || "page"}`}>{children}</HeroBanner>;
  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && <p className="label-eyebrow">{eyebrow}</p>}
        <h1 className="mt-1 font-display text-3xl font-700 tracking-tight sm:text-4xl">{title}</h1>
        {description && <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{description}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
